var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "upcoming-event-report-container" }, [
    _c(
      "div",
      { staticClass: "row" },
      _vm._l(_vm.reports, function(item) {
        return _c(
          "div",
          { staticClass: "col-md-6 col-lg-4" },
          [_c("EventChart", { key: item.id, attrs: { eventItem: item } })],
          1
        )
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-825b2ada", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-825b2ada","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eventManagement/reports/UpcommingReport.vue
// module id = 2101
// module chunks = 1